'use strict';

var Signal = require('@getgo/signal');

function ParentPluginNode(parent) {
  this.parent = null;
  this._hasChild = false;
  this._treeVersion = -1;

  this.signals = Object.assign(this.signals || {}, {
    onAncestryChanged: new Signal()
  });

  this.updateParent(parent);
}


ParentPluginNode.prototype._checkAncestry = function checkAncestry() {
  var nodeList;
  var root;
  var node = this;

  var treeVersion = node.root._treeVersion;

  if (node._treeVersion === treeVersion) return true;

  nodeList = [];

  while (node) {
    nodeList.push(node);
    node = node.parent;
  }

  root = nodeList.pop();

  while ((node = nodeList.pop())) {
    if (root !== node.root) continue;
    if (node._treeVersion !== treeVersion) {
      node.signals.onAncestryChanged.dispatch();
      node._treeVersion = treeVersion;
    }
  }

  return false;
};

ParentPluginNode.prototype.updateParent = function updateParent(p) {
  var parent = p || this.root;
  var node = parent;
  if (this === this.root) return;

  if (parent.root !== this.root) {
    throw new Error('Cannot switch node to other tree');
  }

  while (node) {
    if (node === this) throw new Error('Cycle detected: parent cannot be a descendant');
    node = node.parent;
  }

  this.parent = parent;
  this.parent._hasChild = true;

  if (this._hasChild) {
    // Only change the tree version if this node is up to date
    // If this node is not up to date, none of its children are
    if (this.root._treeVersion === this._treeVersion) {
      this.root._treeVersion++;
    }
  }

  if (this._checkAncestry()) {
    // This node's tree version was up to date, but parent changed
    // We're a simple leaf node, manually notify of ancestry change
    this.signals.onAncestryChanged.dispatch();
  }
};

function ParentPluginRootNode() {
  this.parent = null;
  this._treeVersion = 0;
}

ParentPluginRootNode.prototype.updateParent = function updateParent() {
};

function getParentPluginNodeMethodOverrides() {
  return {
    create: function create() {
      var args = [this];
      Array.prototype.push.apply(args, arguments);
      return create._super.apply(this, args);
    }
  };
}

module.exports = {
  pluginName: 'parent',

  nodeInit: ParentPluginNode,
  nodeMethods: ParentPluginNode.prototype,
  getNodeMethodOverrides: getParentPluginNodeMethodOverrides,

  rootMethods: ParentPluginRootNode.prototype,
  rootInit: ParentPluginRootNode
};
